export default __webpack_public_path__ + "static/media/ContactIcon.187a686d.png";